<template>
  <div class="instruction" :class="{ instruction_box3: box3 }">
    <slot name="title"></slot>
    <div class="container">
      <div class="box box_left" :class="{ box2, box3 }">
        <slot name="left"></slot>
      </div>
      <div class="arrow"></div>
      <div class="box box_right" :class="{ box2, box3 }">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    box2: {
      type: Boolean,
      default: false,
    },
    box3: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.instruction {
  background: linear-gradient(to bottom, #146bee, #0094e3);
  position: relative;
  filter: drop-shadow(0 5px 3px rgba(0, 0, 0, 0.7));
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      background-color: #0099ff;
      border: 3px solid #fff;
      color: #fff;
      height: 220px;
    }
    .box2 {
      height: 280px;
    }
    .box3 {
      height: 460px;
    }
    .box_left {
      width: 55%;
      position: relative;
      background-color: rgba(0, 0, 0, 0);
      border-right: none;
      padding: 20px;
    }
    .box_left::before {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      width: 3px;
      height: 48%;
      background: linear-gradient(to bottom, transparent, transparent 0%, #fff 0%, #fff 100%);
    }
    .box_left::after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      width: 3px;
      height: 47%;
      background: linear-gradient(to bottom, transparent, transparent 0%, #fff 0%, #fff 100%);
    }
    .box3.box_left::after {
      height: 48.5%;
    }
    .box_right {
      width: 45%;
      border-left: none;
      background-color: rgba(0, 0, 0, 0);
      padding: 10px 5px;
    }
    .arrow {
      position: relative;
      width: 15px;
      height: 16px;
      margin-left: -3px;
      border-bottom: 3px solid #fff;
    }
    .arrow::after {
      content: '';
      position: absolute;
      top: 100%;
      right: -15px;
      transform: translateY(-50%);
      border-top: 10px solid transparent;
      border-bottom: 10px solid transparent;
      border-left: 15px solid #fff;
    }
  }
}
.instruction::after {
  content: '';
  position: absolute;
  bottom: -29px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 30px 0 30px;
  border-color: #0094e3 transparent transparent transparent;
  filter: drop-shadow(0 5px 3px rgba(0, 0, 0, 0.7));
}
.instruction_box3::after {
  display: none;
}

@media screen and (max-width: $tabletWidth) {
  .instruction {
    .container {
      .arrow {
        height: 25px;
      }
      .box {
        height: 165px;
      }
      // .box2 {
      //   height: 220px;
      // }
      .box3 {
        height: 240px;
      }
      .box_left::after {
        height: 43%;
      }
      .box_left {
        padding: 5px;
      }
      // .box2::after {
      //   height: 45%;
      // }
      .box3.box_left::after {
        height: 46%;
      }
    }
  }
  .instruction::after {
    bottom: -20px;
    border-width: 20px 20px 0 20px;
  }
}
</style>
